import { fabric } from "@utils/fabric";
import {
  TextLeft,
  TextRight,
  TextCenter,
  Justify,
} from "react-bootstrap-icons";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function FontAlign() {
  const { canvas, selectedObject } = useContext(AppContext);
  const [textAlign, setTextAlign] = useState(
    (selectedObject as fabric.Textbox)?.textAlign
  );

  // triggered by clicking layers
  useEffect(() => {
    setTextAlign((selectedObject as fabric.Textbox)?.textAlign);
  }, [selectedObject]);

  function onClick(newTextAlign: string) {
    if (textAlign === newTextAlign) {
      setTextAlign("");
      (selectedObject as fabric.Textbox)?.set({ textAlign: "" });
    } else {
      setTextAlign(newTextAlign);
      (selectedObject as fabric.Textbox)?.set({ textAlign: newTextAlign });
    }
    canvas?.renderAll();
  }

  return (
    <div className="flex gap-2">
      <button
        className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
          textAlign === "left" 
            ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
            : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
        }`}
        onClick={onClick.bind(null, "left")}
      >
        <TextLeft size={16} />
      </button>
      <button
        className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
          textAlign === "center" 
            ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
            : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
        }`}
        onClick={onClick.bind(null, "center")}
      >
        <TextCenter size={16} />
      </button>
      <button
        className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
          textAlign === "right" 
            ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
            : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
        }`}
        onClick={onClick.bind(null, "right")}
      >
        <TextRight size={16} />
      </button>
      <button
        className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
          textAlign === "justify" 
            ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
            : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
        }`}
        onClick={onClick.bind(null, "justify")}
      >
        <Justify size={16} />
      </button>
    </div>
  );
}

export default FontAlign;
